"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDiscountSchema = exports.createDiscountRuleSchema = exports.DISCOUNT_ACCESS_TYPES = exports.DISCOUNT_RULE_TYPES = void 0;
const zod_1 = require("zod");
exports.DISCOUNT_RULE_TYPES = ['PERCENTAGE', 'FIXED_AMOUNT'];
exports.DISCOUNT_ACCESS_TYPES = ['GENERAL', 'EMPLOYEE', 'REFERRAL', 'SENIOR_CITIZEN', 'STAFF_FAMILY'];
exports.createDiscountRuleSchema = zod_1.z.object({
    discountCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    discountType: zod_1.z.enum(exports.DISCOUNT_RULE_TYPES),
    accessType: zod_1.z.enum(exports.DISCOUNT_ACCESS_TYPES).default('GENERAL'),
    discountValue: zod_1.z.number().nonnegative(),
    maxDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
    requiresApprovalAbovePercent: zod_1.z.number().min(0).max(100).optional(),
});
exports.validateDiscountSchema = zod_1.z.object({
    discountRuleId: zod_1.z.string().uuid().optional(),
    sellingPrice: zod_1.z.number().int().nonnegative(),
    requestedDiscountPercent: zod_1.z.number().min(0).max(100),
    discountAllowed: zod_1.z.boolean(),
    lineMaxDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
});
//# sourceMappingURL=discount-rule.schema.js.map